<template>
  <div>
    <Navbar activeDirectory="map" activePage="realtime-map"></Navbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-8">
                  <l-map
                    v-if="mode == 'teams'"
                    style="height: calc(100vh - 280px); width: 100%"
                    class="border"
                    :zoom="zoom"
                    :center.sync="center"
                    @update:zoom="zoomUpdated"
                    @update:center="centerUpdated"
                    @update:bounds="boundsUpdated"
                  >
                    <l-tile-layer :url="url"></l-tile-layer>
                    <l-geo-json :geojson="geojson" :options="geojsonOptions"></l-geo-json>
                  </l-map>

                  <l-map v-if="mode=='timeline'" style="height: calc(100vh - 280px); width: 100%"
                    class="border"
                    :zoom="zoom"
                    :center.sync="center"
                    @update:zoom="zoomUpdated"
                    @update:center="centerUpdated"
                    @update:bounds="boundsUpdated">
                    <l-tile-layer :url="url"></l-tile-layer>

                    <l-marker v-for="item in timelineItems" v-bind:key="item.id" :lat-lng="getLatLng(item)" >
                    <l-icon
                      :icon-size="[80, 98]"
                      :icon-anchor="[40, 20]"
                      :icon-url="setIconUrl(item)" >
                    </l-icon>
                      <l-popup>
                        <table class="table table-striped border table-sm">
                          <tbody>
                            <tr>
                              <td><b>Intevento</b></td>
                              <td><b>{{ item.intervento.toUpperCase() }}</b></td>
                            </tr>
                            <tr>
                              <td>Tipologia</td>
                              <td>{{ item.tipo_evento.toUpperCase() }}</td>
                            </tr>                            
                            <tr>
                              <td>Data</td>
                              <td>{{ item.tempo }}</td>
                            </tr>
                            <tr>
                              <td>Foto</td>
                              <td><img :src="item.foto" :alt="item.intervento" style="max-width: 160px;"></td>
                            </tr>                            
                          </tbody>
                        </table> 
                      </l-popup>
                    </l-marker>
                  </l-map>
                </div>

                <div class="col col-lg-4" v-if="mode=='teams'">
                  <div class="card">
                    <div class="card-body">
                      <h2 class="font-bold">Lotto: {{ lotto }}</h2>
                      <a class="btn btn-primary text-white" @click="cambiaLotto()">Cambia</a>
                    </div>
                  </div>

                  <p v-if="loading" class="mt-2">Caricamento dati...</p>                  

                  <table class="table table-sm border" v-else>
                    <tbody>
                      <tr
                        v-for="item in features"
                        :class="[{'bg-primary text-white': selectedFeatureId == item.id}]"
                        v-bind:key="item.id"
                      >
                        <td style="width: 20px;">
                          <i
                            v-if="item.geometry.coordinates[0] != 0 && item.geometry.coordinates[1] != 0"
                            class="ml-2 fa"
                            :class="[{'fa-eye' : !item.properties.hide}, {'fa-eye-slash' : item.properties.hide}]"
                            @click="item.properties.hide=!item.properties.hide"
                            style="cursor: pointer;"
                          ></i>
                        </td>
                        <td class="text-left">
                          <b>{{ item.properties.team }}</b>
                        </td>
                        <td class="text-right">
                          <i
                            v-if="(item.geometry.coordinates[0] != 0 && item.geometry.coordinates[1] != 0) && !item.properties.hide"
                            class="ti ti-pin"
                            style="cursor: pointer;"
                            @click="selectedFeatureId=item.id; setCenter(item.geometry)"
                            title="Trova su mappa"
                          ></i>
                          
                          <i class="fa fa-history ml-2" style="cursor: pointer;" @click="selectedFeatureId=item.id; mode='timeline'; team=item.properties.team;" title="Storico interventi"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <button
                    class="btn btn-primary btn-sm mb-2"
                    v-if="mode=='teams'"
                    @click="startLoadFeatures()"
                  >Aggiorna Dati</button>                  
                </div>

                <div class="col col-lg-4" v-if="mode=='timeline'">
                  Attività recenti squadra: <b>{{ team }}</b>
                  <br>
                  <p v-if="loading" class="mt-2">Caricamento dati...</p>
                  <table class="table table-sm border mt-2" v-else>
                    <tbody>
                      <tr v-for="item in timelineItems" v-bind:key="item.id">
                        <td><b>{{ item.intervento.toUpperCase() }}</b></td>
                        <td>{{ item.tipo_evento.toUpperCase() }}</td>                        
                        <td>{{ item.tempo }}</td>
                        <td>
                          <i
                            class="ti ti-pin"
                            style="cursor: pointer;"
                            @click="findCenter(item)"
                            title="Trova su mappa"
                          ></i>
                        </td>                                               
                      </tr>
                    </tbody>
                  </table>
                  <button
                    class="btn btn-primary btn-sm mb-2"
                    v-if="mode=='timeline'"
                    @click="mode='teams'"
                  >Torna a Squadre</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { latLng, icon, marker } from "leaflet";
import { Navbar } from "@/components";

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      mode: 'teams',
      zoom: 9,
      center: undefined,
      bounds: null,
      rotation: 0,
      features: [],
      selectedFeatures: [],
      selectedFeatureId: null,
      loading: false,
      url_old: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      url: "https://mt1.google.com/vt/lyrs=y@129&hl=en&x={x}&y={y}&z={z}&s=Galileo",
      geojson: null,
      timeline: {},
      team: null,
      lotto: 1
    };
  },

  mounted() {
    this.startLoadFeatures();
  },

  created() {
    // Get lotto
    if (localStorage.getItem("lotto")) {
      this.lotto = localStorage.getItem("lotto");
    } 
  },

  watch: {
    mode (nv) {
      if (nv==='timeline') {
        this.fetchTimelineData()
      }
    }
  },

  computed: {
    geojsonOptions() {
      return {
        onEachFeature: this.onEachGeojsonFeature,
        pointToLayer: function (feature, latlng) {
          if (!feature.properties.hide) {
            let iconURl = `images/markers/${feature.properties.tipologia}-sm.png`;
            let marker_icon = icon({
              iconUrl: iconURl,
              iconSize: [80, 98],
              iconAnchor: [40, 20],
            });
            return marker(latlng, {
              icon: marker_icon,
            });
          }
        },
      };
    },

    onEachGeojsonFeature() {
      return (feature, layer) => {
        let popup_html = `
          <table class="table table-striped table-sm border">
            <tbody>
              <tr>
                <td><b>Squadra</td>
                <td><b>${feature.properties.team}</b></td>
              </tr>
              <tr>
                <td>Latitudine</td>
                <td>${feature.geometry.coordinates[1].toFixed(4)}</td>
              </tr>
              <tr>
                <td>Longitudine</td>
                <td>${feature.geometry.coordinates[0].toFixed(4)}</td>
              </tr>
            </tbody>
          </table>
          <i>Ultima posizione al ${feature.properties.last_update}</i>
        `;
        layer.bindPopup(popup_html, { permanent: false, sticky: true });
      };
    },

    timelineItems() {
      let timeline = this.timeline;
      var tItems = [];
      var items = Object.values(timeline)
      for (var i in items) {
        let item = items[i]
        if(item['tipo_evento']=='segnalazione'){
          tItems.push(item);
        } else {
          tItems.push({
            id: item['id'] + 'fine',
            tempo: item['inizio'],
            intervento: item['intervento'],
            foto: item['foto_inizio'],
            latitudine: item['latitudine_inizio'],
            longitudine: item['longitudine_inizio'],
            note: item['note'],
            strada: item['strada'],
            tipo_evento: 'inizio lavoro'
          })
          if(item['fine']){
            tItems.push({
              id: item['id'],
              intervento: item['intervento'],
              tempo: item['fine'],
              foto: item['foto_fine'],
              latitudine: item['latitudine_fine'],
              longitudine: item['longitudine_fine'],
              note: item['note'],
              strada: item['strada'],
              tipo_evento: 'fine lavoro'
            })
          } 
        }
      }
      return tItems;
    }
  },

  methods: {
    startLoadFeatures() {
      this.loading = true;
      this.getGeojson();
    },

    loadFeatures() {
      return new Promise((resolve) => {
        this.axios.get(`fleet-management/gps-positions/${this.lotto}`).then((response) => {
          resolve(response.data.features);
        });
      });
    },

    getGeojson() {
      this.axios.get(`fleet-management/gps-positions/${this.lotto}`).then((response) => {
        this.features = response.data.features;
        this.geojson = response.data;
        for (var i in response.data.features) {
          let geometry = response.data.features[i].geometry;
          if (geometry.coordinates[0] != 0 && geometry.coordinates[1] != 0) {
            this.setCenter(geometry);
            this.selectedFeatureId = response.data.features[i].id;
            break;
          }
        }

        this.loading = false;
      });
    },

    fetchTimelineData() {
    console.log(`Fetching timeline data for team ID: ${this.selectedFeatureId}`);

    this.loading = true;
    
    this.axios.get(`team/${this.selectedFeatureId}/timeline?limit=10`)
      .then(response => {
        console.log("Timeline data received:", response.data);
        this.timeline = response.data;
      })
      .catch(error => {
        console.error("Error fetching timeline data:", error);
      })
      .finally(() => {
        this.loading = false;
        console.log("Fetch operation completed.");
      });
  },


    findCenter(item) {
      let geometry = {}
      geometry = {
        coordinates: [
          item.longitudine,
          item.latitudine            
        ]
      }
      this.setCenter(geometry)  
    },

    getLatLng(item) {
      let geometry = {}
      geometry = {
        coordinates: [
          item.latitudine,
          item.longitudine                      
        ]
      }   
      return geometry.coordinates;
    },

    zoomUpdated(zoom) {
      this.zoom = zoom;
    },

    centerUpdated(center) {
      this.center = center;
    },

    boundsUpdated(bounds) {
      this.bounds = bounds;
    },

    setCenter(geometry) {
      this.center = latLng(geometry.coordinates[1], geometry.coordinates[0]);
      // this.$nextTick(()=>{
      //   this.zoom = 12;
      // })
      
    },

    setIconUrl(item) {
      return `images/markers/${item.tipo_evento.replace(' ','-')}-${item.intervento}-sm.png`
    },

    // Viene cambiato il lotto
    // da 1 a 2 o viceversa
    cambiaLotto() {
      if (this.lotto == 1) {
        this.lotto = 2;
      } else {
        this.lotto = 1;
      }
      localStorage.setItem("lotto", this.lotto);
      this.getGeojson()
    },
  },
};
</script>

<style>
</style>